import { AxiosResponse } from 'axios';
import { FBaseService } from '@kasasa/fbase-components/lib';
import { InterestSettings } from './InterestSettings';

export class InterestSettingsResource extends FBaseService {
  public async getInterestSettings(fiId: string): Promise<InterestSettings> {
    const response: AxiosResponse = await this.apiClient.get(
      `/api/rcx/config/${fiId}/interest`,
    );
    const result: InterestSettings = response.data.data;
    return result;
  }
}

export default InterestSettingsResource;
